export default "__VITE_ASSET__86ed11ee__"